export default __webpack_public_path__ + "static/media/order-sent.8f236dcd.svg";